import StepperComponent from "slotworks/components/ui/stepper-component";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractStepperControl extends AbstractControl implements Control {

    protected stepperComponent: StepperComponent;
    protected value: number;
    protected range: number[];
    protected setupData: boolean = false;
    protected title: FlexiText;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        const downButton = this.layer.getFlexiButton(assetName + "_down");
        const upButton = this.layer.getFlexiButton(assetName + "_up");

        const value = this.layer.getFlexiText(assetName + "_value");
        this.title = this.layer.getFlexiText(assetName + "_title");

        this.stepperComponent = new StepperComponent(downButton, upButton, value);
    }

    public setFormatFunction(formatFunction: (value: number) => string) {
        this.stepperComponent.formatFunction = formatFunction;
    }

    public setupValues(range: number[], current: number) {
        this.range = range;
        this.value = current;

        this.stepperComponent.setValues(range);
        this.stepperComponent.setSelectedValue(current);
    }

    public setSelectedValue(value: number) {
        this.stepperComponent.setSelectedValue(value);
    }

    public setValueVisible(visible: boolean) {
        this.stepperComponent.setValueVisible(visible);
    }

    public setVisible(visible: boolean) {
        if (this.title) {
            this.title.setVisible(visible);
        }

        this.stepperComponent.setVisible(visible);
    }

    public setEnabled(enabled: boolean) {
        if (this.stepperComponent) {
            this.stepperComponent.setEnabled(enabled);
        }

        super.setEnabled(enabled);
    }

    public destroy() {
        this.stepperComponent.destroy();
    }
}
